
import {Info} from 'react-feather'
import {Tooltip} from "react-tooltip";

const Label = (options) => {

    const label = options && options.label != undefined ? options.label : 'Field: '
    const error = options && options.error != undefined ? options.error : null;
    const required = options && options.required != undefined ? options.required : false;


    return (
        <div>
            <label className="Label">
                {required && <span className="text-red required">* </span>}
                {options && options.info && <div className="d-inline"><Info data-tip={options.info} /></div> }{label}
                {error && <span className="error">{error}</span>}
                <Tooltip/>
                {/*Se volvió a añadir el componente ReactTooltip
                porque dentro del label Sender de Sms no se mostraba
                la información*/}
            </label>
        </div>
    )
}

export default Label;